import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import {Modal, ModalBody, Button, Table} from 'reactstrap';
import { sharedLabelsPath } from '../../../../../reducers/common/localization';
import './CreditsHistoryModal.css';
import moment from 'moment';
import {CURRENCIES} from '../../../../../constants/constants';
import PaginationCreditsHistory from '../../../../commonComponents/paginationComponent/PaginationCreditsHistory.container';

class CreditsHistoryModal extends Component {
    render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalBody>
                    <h5 className="credit-history-label">
                        {_.get(this.props.translation, 'system_payment.credit_history_label')
                            .replace('{name}', this.props.companyName)}
                    </h5>
                    <PaginationCreditsHistory />
                    {this.renderData()}
                    <div className="contact-data-modal-button-container">
                        <Button className="olive-green-btn" onClick={this.props.onCancel}>
                            {_.get(this.props.translation, sharedLabelsPath.okey_button)}
                        </Button>
                    </div>
                </ModalBody>
            </Modal>
        );
    }

    renderData = () => {
        if (this.props.loading) {
            return (
                <div className="companies-credits-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }

        if (!this.props.loading && _.isEmpty(this.props.data)) {
            return (
                <div className="credit-history-status-message-container">
                    <h6 className="text-center">{_.get(this.props.translation, 'system_payment.no_company_credits')}</h6>
                </div>
            );
        }

        return (
            <Table className='companies-credits-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, 'system_payment.date_label')}</th>
                    <th>{_.get(this.props.translation, 'system_payment.value_of_change_label')}</th>
                    <th>{_.get(this.props.translation, 'system_payment.comment_label')}</th>
                </tr>
                </thead>
                <tbody>
                {this.renderTableContent()}
                </tbody>
            </Table>
        )
    }

    renderTableContent = () => {
        return _.map(this.props.data, (data, index) => (
            <tr key={index}>
                <td className='name-td' data-th={_.get(this.props.translation, 'system_payment.date_label') + ':'}>
                    {moment(data.date).format('L')}
                </td>
                <td className='date-joined-td' data-th={_.get(this.props.translation, 'system_payment.value_of_change_label') + ':'}>
                    {data.delta.amount + " " + CURRENCIES[data.delta.currency]}
                </td>
                <td className='open-credit-td' data-th={_.get(this.props.translation, 'system_payment.comment_label') + ':'}>
                    {data.comment}
                </td>
            </tr >
        ));
    }
}

CreditsHistoryModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    data: PropTypes.array,
    companyName: PropTypes.string,
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onCancel: PropTypes.func.isRequired
};

export default CreditsHistoryModal;



// WEBPACK FOOTER //
// ./src/components/paymentManagement/systemPaymentComponent/companiesCreditsList/creditsHistoryModal/CreditsHistoryModal.js